import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPharmacist = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 17,
	viewBox: "0 0 14 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 0.484863C4.79086 0.484863 3 2.27572 3 4.48486C3 6.694 4.79086 8.48486 7 8.48486C9.20914 8.48486 11 6.694 11 4.48486C11 2.27572 9.20914 0.484863 7 0.484863ZM4 4.48486C4 2.82801 5.34315 1.48486 7 1.48486C8.65685 1.48486 10 2.82801 10 4.48486C10 6.14172 8.65685 7.48486 7 7.48486C5.34315 7.48486 4 6.14172 4 4.48486Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.00873 9.48486C0.903151 9.48486 0 10.3717 0 11.4849C0 13.1761 0.83281 14.4512 2.13499 15.2815C3.41697 16.0989 5.14526 16.4849 7 16.4849C8.85474 16.4849 10.583 16.0989 11.865 15.2815C13.1672 14.4512 14 13.1761 14 11.4849C14 10.3804 13.1045 9.48487 12 9.48487L2.00873 9.48486ZM1 11.4849C1 10.9316 1.44786 10.4849 2.00873 10.4849L12 10.4849C12.5522 10.4849 13 10.9327 13 11.4849C13 12.7937 12.3777 13.7686 11.3274 14.4383C10.2568 15.1209 8.73511 15.4849 7 15.4849C5.26489 15.4849 3.74318 15.1209 2.67262 14.4383C1.62226 13.7686 1 12.7937 1 11.4849Z",
			fill: "#999999"
		})
	]
});
const ForwardRef = forwardRef(SvgPharmacist);
export default ForwardRef;
